import React from 'react';
import { FormattedMessage } from 'react-intl';
import localeMessages from '../locales/register';
import '../static/MobileLaymensTerms.css';
import SocialShare from '../assets/viewer-consent/laymen-social-share.png';
import VideoShare from '../assets/viewer-consent/laymen-video-share.png';

const MobileLaymensTerms = (props) => {

	const {
		continueStudy,
		intl,
		ndaPrompt
	} = props;

	return (
		<div className="laymens-terms-mobile-container">
			{ ndaPrompt && ndaPrompt.agreement ?
				ndaPrompt.agreement
				:
				<FormattedMessage
					id="viewer_consent.laymens.thanks"
					defaultMessage={`Thank you for keeping this study confidential. Your digital signature means {agreement}`}
					values={{ agreement: <b>{intl.formatMessage(localeMessages.agreement)}</b> }}/>
			}
			<div className="content-container">
				<div className="warning-container">
					<img className="image" src={SocialShare} alt="Social Media Sharing" style={{ width: "23%" }}/>
					<div className="warning">
						{ ndaPrompt && ndaPrompt.laymens_social_media_agreement ?
							ndaPrompt.laymens_social_media_agreement
							:
							<FormattedMessage
								id="viewer_consent.laymens.social_media"
								defaultMessage={`{social_media_instructions} Related To Your Experience On Social Media`}
								values={{ social_media_instructions: <u>{intl.formatMessage(localeMessages.social_media_instructions)}</u> }}/>
						}
					</div>
				</div>
				<div className="warning-container share-content-container">
					<img className="image" src={VideoShare} alt="Video Sharing" style={{ width: "23%" }}/>
					<div className="warning">
						{ ndaPrompt && ndaPrompt.laymens_video_share_agreement ?
							ndaPrompt.laymens_video_share_agreement
							:
							<FormattedMessage
								id="viewer_consent.laymens.store_content"
								defaultMessage={`{store_content_instructions} (Video, Images, etc) From This Study`}
								values={{ store_content_instructions: <u>{intl.formatMessage(localeMessages.store_content_instructions)}</u> }}/>
						}
					</div>
				</div>
			</div>
			<button className={"waves-effect waves-light btn register-field-submit begin-registration offOnTrans on"} onClick={continueStudy}>
				{ndaPrompt && ndaPrompt.laymens_understand_consent ?
					ndaPrompt.laymens_understand_consent
					:
					<FormattedMessage
						id="viewer_consent.laymens.button.understand"
						defaultMessage={`I Understand the Above`}/>
				}
			</button>
		</div>
	);
};

export default MobileLaymensTerms;


// WEBPACK FOOTER //
// ./src/pages/MobileLaymensTerms.js